export const title = 'Average opens';

Average number of opens per campaign. An open happens when a user opens the notification they received.
